import { Box, Button, Flex, Input, Text } from '@modusign/design-system';
import { Fragment } from 'react';

import ChipLabel from '@app/components/UserCompanyDetailInformation/ChipLabel';
import { Survey } from '@app/containers/Modal/WelcomeSurveyModal';
import {
  EXPECTED_START_TIMES,
  EXPECTED_USAGES,
} from '@app/containers/Modal/WelcomeSurveyModal/fixtures';

interface ExpectedUsageStepProps {
  nextStep: () => void;
  survey: Survey;
  setSurvey: (update: (survey: Survey) => Survey) => void;
}

function ExpectedUsageStep({ nextStep, survey, setSurvey }: ExpectedUsageStepProps) {
  const isFormValid = !!survey.expectedUsage && !!survey.expectedStartTime;

  return (
    <>
      <Box fontSize={2} fontWeight="medium" mt={2}>
        계약을 얼마나 진행하시나요?
      </Box>
      <Box mt={8}>
        <Box>
          <Text fontWeight="medium">1년 간 예상 체결 계약</Text>
        </Box>
        <Box maxWidth="400px" mt={3}>
          {EXPECTED_USAGES.map(({ title, value }) => (
            <Fragment key={value}>
              <Input
                checked={survey.expectedUsage === value}
                display="none"
                id={value}
                required
                type="radio"
                value={value}
                onChange={() => setSurvey((prev) => ({ ...prev, expectedUsage: value }))}
              />
              <ChipLabel active={survey.expectedUsage === value} htmlFor={value}>
                {title}
              </ChipLabel>
            </Fragment>
          ))}
        </Box>
        <Box mt={7}>
          <Text fontWeight="medium">모두싸인 도입 시기</Text>
        </Box>
        <Box mt={3}>
          {EXPECTED_START_TIMES.map((value) => (
            <Fragment key={value}>
              <Input
                checked={survey.expectedStartTime === value}
                display="none"
                id={value}
                required
                type="radio"
                value={value}
                onChange={() => setSurvey((prev) => ({ ...prev, expectedStartTime: value }))}
              />
              <ChipLabel active={survey.expectedStartTime === value} htmlFor={value}>
                {value}
              </ChipLabel>
            </Fragment>
          ))}
        </Box>
        <Flex alignItems="center" justifyContent="end" mt={9}>
          <Button disabled={!isFormValid} ml={6} variant="primary" onClick={nextStep}>
            다음
          </Button>
        </Flex>
      </Box>
    </>
  );
}

export default ExpectedUsageStep;
